import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\AlertController::index
* @see app/Http/Controllers/AlertController.php:33
* @route '/anunciante/alerts'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/anunciante/alerts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AlertController::index
* @see app/Http/Controllers/AlertController.php:33
* @route '/anunciante/alerts'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AlertController::index
* @see app/Http/Controllers/AlertController.php:33
* @route '/anunciante/alerts'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AlertController::index
* @see app/Http/Controllers/AlertController.php:33
* @route '/anunciante/alerts'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AlertController::index
* @see app/Http/Controllers/AlertController.php:33
* @route '/anunciante/alerts'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AlertController::index
* @see app/Http/Controllers/AlertController.php:33
* @route '/anunciante/alerts'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AlertController::index
* @see app/Http/Controllers/AlertController.php:33
* @route '/anunciante/alerts'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\AlertController::matchesCount
* @see app/Http/Controllers/AlertController.php:124
* @route '/anunciante/alerts/matches-count'
*/
export const matchesCount = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: matchesCount.url(options),
    method: 'get',
})

matchesCount.definition = {
    methods: ["get","head"],
    url: '/anunciante/alerts/matches-count',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AlertController::matchesCount
* @see app/Http/Controllers/AlertController.php:124
* @route '/anunciante/alerts/matches-count'
*/
matchesCount.url = (options?: RouteQueryOptions) => {
    return matchesCount.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AlertController::matchesCount
* @see app/Http/Controllers/AlertController.php:124
* @route '/anunciante/alerts/matches-count'
*/
matchesCount.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: matchesCount.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AlertController::matchesCount
* @see app/Http/Controllers/AlertController.php:124
* @route '/anunciante/alerts/matches-count'
*/
matchesCount.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: matchesCount.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AlertController::matchesCount
* @see app/Http/Controllers/AlertController.php:124
* @route '/anunciante/alerts/matches-count'
*/
const matchesCountForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: matchesCount.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AlertController::matchesCount
* @see app/Http/Controllers/AlertController.php:124
* @route '/anunciante/alerts/matches-count'
*/
matchesCountForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: matchesCount.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AlertController::matchesCount
* @see app/Http/Controllers/AlertController.php:124
* @route '/anunciante/alerts/matches-count'
*/
matchesCountForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: matchesCount.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

matchesCount.form = matchesCountForm

/**
* @see \App\Http\Controllers\AlertController::store
* @see app/Http/Controllers/AlertController.php:75
* @route '/anunciante/alerts'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/anunciante/alerts',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AlertController::store
* @see app/Http/Controllers/AlertController.php:75
* @route '/anunciante/alerts'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AlertController::store
* @see app/Http/Controllers/AlertController.php:75
* @route '/anunciante/alerts'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AlertController::store
* @see app/Http/Controllers/AlertController.php:75
* @route '/anunciante/alerts'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AlertController::store
* @see app/Http/Controllers/AlertController.php:75
* @route '/anunciante/alerts'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\AlertController::update
* @see app/Http/Controllers/AlertController.php:88
* @route '/anunciante/alerts/{alert}'
*/
export const update = (args: { alert: string | number | { id: string | number } } | [alert: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/anunciante/alerts/{alert}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\AlertController::update
* @see app/Http/Controllers/AlertController.php:88
* @route '/anunciante/alerts/{alert}'
*/
update.url = (args: { alert: string | number | { id: string | number } } | [alert: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { alert: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { alert: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            alert: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        alert: typeof args.alert === 'object'
        ? args.alert.id
        : args.alert,
    }

    return update.definition.url
            .replace('{alert}', parsedArgs.alert.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AlertController::update
* @see app/Http/Controllers/AlertController.php:88
* @route '/anunciante/alerts/{alert}'
*/
update.patch = (args: { alert: string | number | { id: string | number } } | [alert: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\AlertController::update
* @see app/Http/Controllers/AlertController.php:88
* @route '/anunciante/alerts/{alert}'
*/
const updateForm = (args: { alert: string | number | { id: string | number } } | [alert: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AlertController::update
* @see app/Http/Controllers/AlertController.php:88
* @route '/anunciante/alerts/{alert}'
*/
updateForm.patch = (args: { alert: string | number | { id: string | number } } | [alert: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\AlertController::destroy
* @see app/Http/Controllers/AlertController.php:104
* @route '/anunciante/alerts/{alert}'
*/
export const destroy = (args: { alert: string | number | { id: string | number } } | [alert: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/anunciante/alerts/{alert}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AlertController::destroy
* @see app/Http/Controllers/AlertController.php:104
* @route '/anunciante/alerts/{alert}'
*/
destroy.url = (args: { alert: string | number | { id: string | number } } | [alert: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { alert: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { alert: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            alert: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        alert: typeof args.alert === 'object'
        ? args.alert.id
        : args.alert,
    }

    return destroy.definition.url
            .replace('{alert}', parsedArgs.alert.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AlertController::destroy
* @see app/Http/Controllers/AlertController.php:104
* @route '/anunciante/alerts/{alert}'
*/
destroy.delete = (args: { alert: string | number | { id: string | number } } | [alert: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\AlertController::destroy
* @see app/Http/Controllers/AlertController.php:104
* @route '/anunciante/alerts/{alert}'
*/
const destroyForm = (args: { alert: string | number | { id: string | number } } | [alert: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AlertController::destroy
* @see app/Http/Controllers/AlertController.php:104
* @route '/anunciante/alerts/{alert}'
*/
destroyForm.delete = (args: { alert: string | number | { id: string | number } } | [alert: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const alerts = {
    index: Object.assign(index, index),
    matchesCount: Object.assign(matchesCount, matchesCount),
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default alerts